<i data-testid="icon" aria-hidden="true" [class]="'fof-icon fof-icon-' + icon"></i>
